import React from 'react';
import { Printer } from 'lucide-react';
import { Button } from '../../components/ui/button';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const KitchenPrintButton = ({ orderId, tableId, items, createdAt, notes }) => {

  const printTicket = async () => {
    const printWindow = window.open('', '_blank', 'width=350,height=600');
    if (!printWindow) {
      alert('Veuillez autoriser les popups pour imprimer');
      return;
    }

    const time = createdAt ? new Date(createdAt).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : '';
    const date = createdAt ? new Date(createdAt).toLocaleDateString('fr-FR') : '';

    const itemsHtml = items.map(item =>
      `<tr><td style="padding:4px 0;font-size:16px;font-weight:bold">${item.quantity}x ${item.name}</td><td style="text-align:right;padding:4px 0">${item.price}B</td></tr>`
    ).join('');

    const notesHtml = notes ? `<div style="border:2px solid #000;padding:8px;margin:8px 0;font-size:14px;"><strong>NOTES:</strong> ${notes}</div>` : '';

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head><title>Cuisine - Table ${tableId}</title>
      <style>
        body { font-family: 'Courier New', monospace; padding: 10px; margin: 0; width: 280px; }
        .header { text-align: center; border-bottom: 2px dashed #000; padding-bottom: 8px; margin-bottom: 8px; }
        .header h1 { margin: 0; font-size: 20px; }
        .header p { margin: 2px 0; font-size: 12px; }
        table { width: 100%; border-collapse: collapse; }
        .footer { border-top: 2px dashed #000; padding-top: 8px; margin-top: 8px; text-align: center; font-size: 11px; }
        @media print { body { width: 72mm; } }
      </style>
      </head>
      <body>
        <div class="header">
          <h1>HIBISUN CUISINE</h1>
          <p><strong>TABLE ${tableId}</strong></p>
          <p>${date} - ${time}</p>
        </div>
        <table>${itemsHtml}</table>
        ${notesHtml}
        <div class="footer">
          <p>Commande #${orderId?.slice(0, 8) || ''}</p>
        </div>
        <div id="pf" style="text-align:center;padding:10px;position:fixed;bottom:0;left:0;right:0;background:#fff;border-top:1px solid #ccc;z-index:999"><button onclick="window.print()" style="padding:12px 40px;font-size:16px;font-weight:bold;background:#0A422D;color:#fff;border:none;border-radius:8px;cursor:pointer">IMPRIMER</button></div><script>setTimeout(function(){try{window.print()}catch(e){}},600)<\/script>
      </body>
      </html>
    `);
    printWindow.document.close();
  };

  return (
    <Button onClick={printTicket} variant="outline" size="sm"
      className="rounded-xl border-[#D4A853] text-[#D4A853] hover:bg-[#D4A853] hover:text-white text-xs"
      data-testid={`print-kitchen-${orderId}`}>
      <Printer className="w-3 h-3 mr-1" /> Cuisine
    </Button>
  );
};
